<template>
  <div class="english-container">
    <h2>Présentation du produit</h2>
    <p  style="text-align: left;" >Nous partageons votre enthousiasme pour les balises sans fil pour les trackers Android qui sont conçus pour s'intégrer de manière transparente à l'application Find Hub de Google et vous aider à suivre vos articles à l'aide de milliards d'appareils Android dans le monde entier.
</p>
  
    <p  style="text-align: left;" >Wireless Tag est un dispositif de suivi intelligent qui utilise le service Google Find Hub, associé à l'application « Find Hub » sur les appareils Android, pour localiser rapidement et en toute sécurité vos objets personnels sur Google Maps. Toutes les informations de localisation restent privées et même Google ne peut pas y accéder.
</p>

<h3> 1. Connectez-vous à l'application Find Hub</h3>
  <ol>
    <li>Accédez à Google Play et recherchez «Find Hub».</li>
    <li>Installez l'application ou cliquez sur «Mettre à jour».</li>
    <li>Cliquez sur « Ouvrir » ou sur l'icône de l'application Find Hub sur la page d'accueil de votre téléphone</li>
    <li>Connectez-vous à la page Find Hub avec votre compte Google. Vous pouvez cocher la case «Ne plus me demander».
Si vous possédez plusieurs comptes, votre article sera lié au compte principal configuré sur votre téléphone.</li>
    <li>Il se peut que l'on vous demande certaines autorisations. Veuillez consulter les conditions d'utilisation et continuer.
</li>
  </ol>

  <h3>2. Mise sous tension</h3>
  <p style="text-align: left;">
    <strong> Mise sous tension: </strong> Maintenez le point circulaire sur le bouton d'alimentation de l'appareil enfoncé pendant 3 secondes et lorsque vous entendez un carillon, cela indique que l'appareil est sous tension. (Reportez-vous au schéma)
  </p>

   <img src="../assets/gid_1.png" alt="Wireless Tag Logo" class="image_1" />

<h3>3. Connectez-vous à l'application Find Hub</h3>
  
      <p style="text-align: left;">
        3.1 Assurez-vous que le Bluetooth de votre téléphone est activé et que vous êtes connecté à Internet.
      </p>
 <p style="text-align: left;">
3.2 Rapprochez votre étiquette de votre téléphone et attendez que la fenêtre contextuelle affiche l'étiquette sans fil. Sur la feuille inférieure de la fenêtre contextuelle, appuyez sur «Connecter». Lisez et acceptez les invites pour terminer l'appairage.
</p>

<h3>4. Présentation du produit</h3>
<h4>4.1 Recherche à proximité</h4>
<p style="text-align: left;">
4.1.1 Vous êtes parfois plus proche de votre objet perdu que vous ne le pensez. Si vous savez qu'il se trouve quelque part dans la maison, Find Hub indiquera la force du signal afin que vous puissiez affiner son emplacement</p>
<p style="text-align: left;">
4.1.2 Si votre appareil est à portée du signal sans fil, sélectionnez-le dans l'application «Find Hub» et appuyez sur «Émettre un son» pour le localiser. Une fois localisé, appuyez sur «Arrêter le son» pour le couper.
</p>
<p style="text-align: left;">
4.1.3 L'Assistant Google sur votre Google Home ou votre Pixel Watch est là pour vous aider. Essayez des invites telles que «Ok Google, trouve mon portefeuille» ou «Ok Google, trouve mes clés» pour retrouver rapidement vos affaires.
</p>
<h4>4.2 Une communauté pour trouver</h4>
  <p style="text-align: left;">
Lorsque vous êtes vraiment loin d'un objet, le réseau Find Hub est là pour vous aider. Les appareils Android du monde entier (tablettes, téléphones et ordinateurs portables) fonctionnent ensemble pour vous aider à retrouver vos objets perdus.
</p>
<h4>4.3 Activer le mode perdu</h4>
 <p style="text-align: left;">
Si vous perdez votre objet, sélectionnez-le dans l'application «Find Hub» et appuyez sur «Marquer comme perdu». Vous recevrez une notification dès que la localisation sera disponible. Vous pouvez laisser vos coordonnées pour que la personne qui a trouvé votre objet puisse vous contacter.  </p>

  <h4>4.4 Partage de localisation</h4>

   <p style="text-align: left;">
Sélectionnez l'appareil dans l'application «Find Hub», puis appuyez sur «Partager l'appareil». Une fois le partage confirmé par le propriétaire de l'accessoire, celui-ci sera visible dans la liste de l'application «Find Hub». Les deux comptes verront les mises à jour de localisation et pourront appeler l'appareil localement.  </p>

  <h4>4.5 Alertes de tracker inconnu</h4>
   <p style="text-align: left;">
Votre sécurité avant tout. Find Hub est conçu pour empêcher tout suivi indésirable. Si votre téléphone Android détecte un appareil inconnu qui se déplace avec vous, vous recevrez une notification. Visualisez l'appareil inconnu sur une carte, faites-le sonner pour le localiser ou obtenez de l'aide.  </p>

  <h4>4.6 Confidentialité</h4>
   <p style="text-align: left;">
Vos données de localisation sont chiffrées de bout en bout, ce qui signifie que Google ne peut ni les consulter ni y accéder. Vous seul pouvez voir où vos objets ont été et se trouvent actuellement. Avec l'application Find Hub, Google n'utilise ni ne partage vos données. Les informations que vous partagez sur vous-même et vos appareils restent confidentielles.  </p>
  
 <h3>5. Remplacement de la batterie</h3>
  <p style="text-align: left;">
      5.1 Insérez l'ouverture de la coque avec un outil d'ouverture de coque.
  </p>

   <p style="text-align: left;">
      5.2 Faites pivoter l’outil d’ouverture de coque de 90 degrés pour ouvrir la coque.
  </p>

   <p style="text-align: left;">
    5.3 Utilisez vos ongles dans le petit espace sur le côté de votre localisateur d'objets pour ouvrir soigneusement le boîtier.  
  </p>

   <p style="text-align: left;">
      5.4 Remplacez la pile par une nouvelle pile CR2032 3V (pôle positif avec le texte vers le haut).
  </p>

     <img src="../assets/open_tag.png" alt="Wireless Tag Logo" class="image_1" />

  <h3>6. Fonction du bouton</h3>
  <ol>
    <li style="text-align: left;">
      Mise sous tension (la fonction «Trouver ma fonction» est activée)
      <p>
Appuyez sur le bouton de fonction pendant 3 secondes pour l'allumer. Un bip sonore devrait indiquer la mise sous tension. Si le produit n'est pas associé à votre compte Google, il se fermera automatiquement dans les 10 minutes. Vous devez réactiver la fonction «Localiser» pour poursuivre l'appairage.
        </p>
    </li>
    <li style="text-align: left;">Mise hors tension (la fonction «Trouver mon» est désactivée).
      <p>
Maintenez le bouton de fonction enfoncé pendant trois secondes,<strong> puis relâchez-le... </strong>vous entendrez deux bips indiquant qu'il est éteint.      </p>
    </li>
    <strong  style="text-align: left;">
      <p>Remarque:</p>
      <p>1. Si vous appuyez dessus pendant moins de 3 secondes ou plus de 5 secondes, l'appareil ne s'éteindra pas</p>
      <p>2. Le réglage d'une minuterie d'arrêt est conçu pour éviter les arrêts accidentels, garantissant que l'appareil peut continuer à localiser efficacement</p>
    </strong>

    <li style="text-align: left;">Restaurer les paramètres d'usine</li>
    <p style="text-align: left;"> 
Appuyez deux fois sur le bouton de fonction, vous pouvez entendre un bip, puis appuyez quatre fois rapidement sur le bouton de fonction, puis maintenez-le enfoncé une cinquième fois jusqu'à ce que vous entendiez un carillon, maintenant l'appareil est réinitialisé.    </p>
  </ol>

  <h3>  FAQ  </h3>
  <h4>Impossible de connecter mon appareil à l'application Localiser mon appareil de Google L'action suivante est recommandée:  </h4>
<ol>
  <li style="text-align: left;">Redémarrez le Bluetooth et le réseau cellulaire de votre téléphone.

Redémarrez le Bluetooth et le réseau cellulaire de votre téléphone, éteignez et redémarrez l'appareil, puis attendez que la fenêtre contextuelle affiche «Balise sans fil».
</li>
  <li style="text-align: left;">Réinitialisez votre appareil. Éteignez-le, puis redémarrez-le. Attendez que la fenêtre contextuelle affiche «Wireless tag».
</li>
  <li style="text-align: left;">Veuillez redémarrer votre téléphone et réessayer.
Veuillez redémarrer votre téléphone, éteindre et redémarrer l'appareil, puis attendre que la fenêtre contextuelle affiche «Wireless tag».
</li>
<li style="text-align: left;"> Mettez à jour le logiciel de votre téléphone.
  <p>
    Étape 1. Accédez aux paramètres du téléphone et recherchez «Système»</p>
<p>Étape 2. Recherchez les mises à jour logicielles et ouvrez «Mise à jour du système», puis recherchez les mises à jour.</p>
<p>Étape 3. Mettez à jour le système de votre téléphone vers le nouveau système.</p>
</li>
<li style="text-align: left;">Recherchez le service Google de votre téléphone pour connecter l’appareil.
  <p>Étape 1. Accédez aux paramètres du téléphone et recherchez «Préférences de service Google».</p>
<p>Étape 2. Accédez aux « Préférences de service Google » et recherchez « Tous les services ».</p>
<p>Étape 3. Accédez à « Tous les services » et recherchez « Appareils connectés et partage ».</p>
<p>Étape 4. Accédez à «Appareils» et recherchez «Appareils disponibles à proximité». Si vous voyez «Wireless tag», cliquez dessus et attendez que la fenêtre contextuelle affiche «Balise sans fil».</p>
<p>Étape 5. Si vous ne voyez pas l'étiquette sans fil, éteignez et redémarrez l'appareil jusqu'à ce qu'elle apparaisse. Vous pouvez également réinitialiser votre appareil, l'éteindre et le redémarrer jusqu'à ce qu'elle apparaisse. Cliquez ensuite sur l'étiquette sans fil, attendez qu'elle apparaisse dans la fenêtre contextuelle et appuyez dessus pour vous connecter.</p>
</li>
</ol>
<p style="text-align: left; color:#333 "  >Une fois lié à un compte Google, l'appareil devient inaccessible aux autres utilisateurs.</p>
<p style="text-align: left; color:#333 "  >Lorsque votre objet est à proximité, vous pouvez le supprimer dans l'application, il devrait émettre un carillon indiquant qu'il a été supprimé avec succès, puis l'objet peut être utilisé par d'autres personnes.</p>
<p style="text-align: left; color:#333 "  >Lorsque votre objet est hors de portée de la connexion de votre téléphone et que votre localisateur est supprimé de l'application Localiser, l'appareil ne peut pas être utilisé par d'autres personnes. Vous devez réinitialiser votre localisateur, il pourra alors être utilisé par d'autres personnes.</p>

<h3>AVERTISSEMENT</h3>
<ol>
  <li> Retirez et recyclez ou jetez immédiatement les piles usagées conformément à la réglementation locale et tenez-les hors de portée des enfants. NE jetez PAS les piles dans les ordures ménagères et ne les incinérez pas.</li>
  <li>Même les piles usagées peuvent provoquer des blessures graves, voire mortelles.</li>
  <li>Appelez un centre antipoison local pour obtenir des informations sur le traitement.</li>
  <li>Les piles non rechargeables ne doivent pas être rechargées.</li>
  <li>Ne pas forcer la décharge, la recharger, le démonter, le chauffer à plus de 50 °C/122 °F ou l'incinérer.</li>
  <li>Cela pourrait entraîner des blessures dues à une fuite, une explosion ou une brûlure chimique. 6. Le type de pile compatible est CR2032.</li>
  <li>Tension nominale de la batterie : DC 3V</li>
  <li>Assurez-vous que les piles sont installées correctement en respectant la polarité (+ et -). 9. Ne mélangez pas des piles neuves et usagées, des marques ou des types de piles différents, tels que des piles alcalines, au carbone-zinc ou rechargeables.</li>
  <li>Retirez et recyclez ou jetez immédiatement les batteries des équipements non utilisés pendant une période prolongée conformément à la réglementation locale.</li>
  <li> Refermez toujours complètement le compartiment à piles. Si le compartiment à piles ne se ferme pas correctement, cessez d'utiliser le produit, retirez les piles et tenez-les hors de portée des enfants.</li>
</ol>
<h5>
  <p>Type de pile : CR2032. Tension de la pile : 3V.</p>
<p>Conserver dans l’emballage d’origine jusqu’à utilisation;</p>
<p>Jetez immédiatement les piles usagées et tenez-les hors de portée des enfants. Ne jetez pas les piles avec les ordures ménagères.</p>
</h5>

<img src="../assets/image_battery.png" class="image_1">

</div>

</template>

<script>
export default {
  name: 'FranceLuage',
};
</script>

<style scoped>
.english-container {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1, h2,h3,h4,h5 {
  color: #333;
 text-align: left; /* 明确标题左对齐（如果父级未继承） */

}
ul, ol {
  margin-left: 20px;
  padding-left: 15px;
 list-style-type: decimal; /* 强制显示数字编号 */

}
li {
  margin-bottom: 8px;
  text-align: left;
  color: #000000;
}

.image_1 {
  width: 90%; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}

</style>